<template>
  <div>
    <div class="container">

      <div v-if="showOptions.display">

      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for=""> {{ $t('ct-theme') }}</label>
            <select v-model="selectTheme.selectedTheme" class="form-control">
              <option v-for="theme in selectTheme.themes" :key="theme" :value="theme">{{ theme }}</option>
            </select>
          </div>
        </div>
        <div v-show="showOptions.button && selectTheme.selectedTheme !== 'hover'" class="col-md-4">
          <div class="form-group">
            <label for=""> {{ $t('ct-read-more-text') }}</label>
            <input type="text" v-model="showOptions.readMoreText" class="form-control">
          </div>
        </div>
        <div v-if="showOptions.date" class="col-md-4">
          <div class="form-group">
            <label for=""> {{ $t('ct-date-format') }}</label>
            <select v-model="showOptions.dateFormat" class="form-control">
              <option v-for="dateFormat in showOptions.dateFormats" :key="dateFormat" :value="dateFormat">{{ datePreview(dateFormat) }}</option>
            </select>
          </div>
        </div>
      </div>

        <div class="row">
          <div class="col-md-12">
            <h5> {{ $t('ct-display-resource_components') }}</h5>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <input type="checkbox" id="show-author" v-model="showOptions.author">
              <label for="show-author"> {{ $t('ct-show-author') }}</label>
            </div>
          </div>
          <div v-if="selectTheme.selectedTheme !== 'hover'"  class="col-md-4">
            <div class="form-group">
              <input type="checkbox" id="show-categories" v-model="showOptions.categories">
              <label for="show-categories"> {{ $t('ct-show-categories') }}</label>
            </div>
          </div>
          <div v-if="selectTheme.selectedTheme !== 'hover'" class="col-md-4">
            <div class="form-group">
              <input  type="checkbox" id="show-thumbnail" v-model="showOptions.thumbnail">
              <label for="show-thumbnail"> {{ $t('ct-show-thumbnail') }}</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <input type="checkbox" id="show-date" v-model="showOptions.date">
              <label for="show-date"> {{ $t('ct-show-date') }}</label>
            </div>
          </div>
          <div v-if="selectTheme.selectedTheme !== 'hover'" class="col-md-4">
            <div class="form-group">
              <input type="checkbox" id="show-content" v-model="showOptions.content">
              <label for="show-content"> {{ $t('ct-show-content') }}</label>
            </div>
          </div>

          <div v-if="selectTheme.selectedTheme !== 'hover'" class="col-md-4">
            <div class="form-group">
              <input type="checkbox" id="show-button" v-model="showOptions.button">
              <label for="show-button"> {{ $t('ct-show-button') }}</label>
            </div>
          </div>

        </div>



      </div>
      <div v-if="selectArticle.display" class="row">
        <div class="col-md-12">
          <h5> {{ $t('ct-featured-resource_components') }}</h5>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <div class="input-group">
              <select v-model="selectArticle.selected" class="form-control">
                <option v-for="article in articles" :key="article.cryptID" :value="article.cryptID"> {{ article.title }} </option>
              </select>
              <span class="input-group-btn">
                <button class="btn btn-primary" @click="getData()" type="button" tabindex="-1">
                  <span class="fas fa-search" aria-hidden="true"></span>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="selectFilter.display" class="row">
        <div class="col-md-12">
          <h5> {{ $t('ct-filters') }}</h5>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="">Category</label>
            <select v-model="selectFilter.category" class="form-control">
              <option value="all">All</option>
              <option v-for="category in categories" :key="category.cryptID" :value="category.cryptID">{{ category.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for=""> {{ $t('ct-author') }}</label>
            <select v-model="selectFilter.author"  class="form-control">
              <option value="all"> {{ $t('ct-all') }}</option>
              <option v-for="author in authors" :key="author.cryptID" :value="author.cryptID">{{ author.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for=""> {{ $t('ct-type') }}</label>
            <select v-model="selectFilter.featured"  class="form-control">
              <option :value="false"> {{ $t('ct-all') }}</option>
              <option :value="true"> {{ $t('ct-featured') }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for=""> {{ $t('ct-order') }}</label>
            <select v-model="selectFilter.mostAccessed"  class="form-control">
              <option :value="false"> {{ $t('ct-date') }}</option>
              <option :value="true"> {{ $t('ct-views') }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for=""> {{ $t('ct-amount') }}</label>
            <select v-model="selectFilter.amount"  class="form-control">
              <option v-for="i in 50" :key="i" :value="i">{{ i }}</option>
            </select>
          </div>
        </div>
        <div
          v-show="selectTheme.display
          && selectTheme.selectedTheme !== 'clean'
          && selectTheme.selectedTheme !== 'list'"
          class="col-md-3"
        >
          <div class="form-group">
            <label for=""> {{ $t('ct-headline') }}</label>
            <select v-model="selectTheme.headline" class="form-control">
              <option v-for="headline in selectTheme.headlines" :key="headline" :value="headline">{{ headline }}</option>
            </select>
          </div>
        </div>

        <div
          v-show="selectTheme.display
          && selectTheme.selectedTheme !== 'clean'
          && selectTheme.selectedTheme !== 'list'"
          class="col-md-3"
        >
          <div class="form-group">
            <label for=""> {{ $t('ct-columns') }}</label>
            <select v-model="selectTheme.columns" class="form-control">
              <option v-for="i in 4" :key="i" :value="i">{{ i }}</option>
            </select>
          </div>
        </div>
      </div>
      <div v-if="feedOptions.display" class="row">
        <div class="col-md-12">
          <h5> {{ $t('ct-feed-resource_components') }}</h5>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for=""> {{ $t('ct-amount') }}</label>
            <select v-model="feedOptions.amount"  class="form-control">
              <option v-for="i in 50" :key="i" :value="i">{{ i }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for=""> {{ $t('ct-type') }}</label>
            <select v-model="feedOptions.featured"  class="form-control">
              <option :value="true"> {{ $t('ct-all') }}</option>
              <option :value="false"> {{ $t('ct-without-featured') }}</option>
            </select>
          </div>
        </div>
        <div
          v-show="selectTheme.display
          && selectTheme.selectedTheme !== 'clean'
          && selectTheme.selectedTheme !== 'list'"
          class="col-md-3"
        >
          <div class="form-group">
            <label for=""> {{ $t('ct-headline') }}</label>
            <select v-model="selectTheme.headline" class="form-control">
              <option v-for="headline in selectTheme.headlines" :key="headline" :value="headline">{{ headline }}</option>
            </select>
          </div>
        </div>

        <div
          v-show="selectTheme.display
          && selectTheme.selectedTheme !== 'clean'
          && selectTheme.selectedTheme !== 'list'"
          class="col-md-3"
        >
          <div class="form-group">
            <label for=""> {{ $t('ct-columns') }}</label>
            <select v-model="selectTheme.columns" class="form-control">
              <option v-for="i in 4" :key="i" :value="i">{{ i }}</option>
            </select>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="float-right">
            <button class="btn btn-success float-right" @click="save"> {{ $t('ct-save') }}</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getAllNews, getCategories, getAuthors } from '../../../../../../js/services/editor/blog.js';
import _ from 'lodash';
import moment from 'moment/moment'

export default {
  name: 'BlogArticleSettings',
  data() {
    return {
      type: 'featured',
      articles: [],
      categories: [],
      authors: [],
      showOptions: {
        display: false,
        author: true,
        categories: true,
        thumbnail: true,
        date: true,
        content: true,
        button: true,
        dateFormat: 'YYYY-MM-DD',
        readMoreText: 'Read More',
        dateFormats: ['YYYY-MM-DD', 'DD/MM/YYYY', 'dddd, MMMM Do YYYY, h:mm:ss a', 'ddd, hA', 'MM-DD-YYYY', 'L', 'LL', 'LLL']
      },
      selectArticle: {
        display: false,
        selected: ''
      },
      selectFilter: {
        display: false,
        category: 'all',
        author: 'all',
        featured: false,
        mostAccessed: false,
        amount: 6
      },
      selectTheme: {
        display: false,
        themes: ['simple', 'clean', 'hover', 'list'],
        selectedTheme: '',
        columns: 1,
        headline: '1-100',
        headlines: ['none', '1-100', '2-50', '3-33', '4-25', 'last-column']
      },
      feedOptions: {
        display: false,
        category: 'all',
        author: 'all',
        featured: false,
        mostAccessed: false,
        amount: 6
      }
    };
  },
  methods: {
    datePreview(format) {
      let locale = window.navigator.userLanguage || window.navigator.language;
      moment.locale(locale);
      return moment().format(format);
    },
    setType(config) {
      this.selectArticle.display = false;
      this.selectFilter.display = false;
      this.selectTheme.display = false;
      this.feedOptions.display = false;

      this.type = config.type;
      this.showOptions = _.merge(this.showOptions, config.card.show);

      if (this.type === 'featured') {
        this.selectArticle.selected = config.selectedArticle;
      }

      if (this.type === 'group') {
        this.selectFilter = _.merge(this.selectFilter, config.filters);
      }

      if (this.type === 'feed') {
        this.feedOptions = _.merge(this.feedOptions, config.filters);
      }

      if (this.type === 'group' || this.type === 'feed') {
        this.selectTheme.columns = config.columns;
        this.selectTheme.headline = config.headline;
      }
      this.selectTheme.selectedTheme = config.theme;
      this.showOptions.dateFormat = config.card.config.dateFormat;
      this.showOptions.readMoreText = config.card.config.readMoreText;

      this.init();
    },
    init() {
      this.showOptions.display = true;

      if (this.type === 'featured') {
        this.selectArticle.display = true;
      }

      if (this.type === 'group') {
        this.selectFilter.display = true;
      }

      if (this.type === 'feed') {
        this.feedOptions.display = true;
      }

      if (this.type === 'group' || this.type === 'feed') {
        this.selectTheme.display = true;
      }

      this.getData();
    },
    getData() {
      let vm = this;

      getAllNews()
        .then(({ data }) => {
          if (data.success) {
            vm.articles = data.data;
          }
        });

      getCategories()
        .then(({data}) => {
          (data.success) ? vm.categories = data.data : console.log('error categories');
        });

      getAuthors()
        .then(({data}) => {
          (data.success) ? vm.authors = data.data : console.log('error authors');
        });
    },
    save() {
      let showOptions = _.clone(this.showOptions);
      delete showOptions['display'];
      let dateFormat = showOptions.dateFormat;
      let readMoreText = showOptions.readMoreText;
      delete showOptions['readMoreText'];
      delete showOptions['dateFormat'];

      let filters = _.clone(this.selectFilter);
      delete filters['display'];

      let feedFilters = _.clone(this.feedOptions);
      delete feedFilters['display'];

      let theme = _.clone(this.selectTheme);
      delete theme['display'];
      delete theme['themes'];
      delete theme['headlines'];

      let obj = {
        showOptions: showOptions,
        selectedArticle: this.selectArticle.selected,
        filters: filters,
        feedFilters: feedFilters,
        dateFormat: dateFormat,
        readMoreText: readMoreText,
        theme: theme
      };

      // default values
      this.selectArticle.display = true;
      this.selectFilter.display = true;

      this.$emit('save', obj);
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
  @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css);
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Settings/content/BlogArticleSettings.vue